import './index.scss'
import { observer } from 'mobx-react-lite'
import { YMaps, Map, Placemark } from 'react-yandex-maps'
// import MailIcon from '../../assets/img/contacts-mail.png'
import MailIconSvg from '../../assets/svg/contacts-mail.svg'
// import PhoneIcon from '../../assets/img/contacts-phone.png'
import PhoneIconSvg from '../../assets/svg/contacts-phone.svg'
import LogoVk from '../../assets/svg/logo-vk-24.svg'
import LogoTg from '../../assets/svg/logo-tg-24.svg'

import useWindowDimensions from '@hooks/useWindowDimensions'

const ContactsPage = observer(() => {
 const { width } = useWindowDimensions()
 return (
  <div className="contacts-page container">
   <h1 className="title">Əlaqə</h1>
   <div className="contacts">
    <div className="information">
     <div className="requisites">
      <h2>Rekvizitlər</h2>
      <p>
       {' '}
       <strong>«Softail» MMC</strong>
      </p>
      <p>VÖEN: 9719033996</p>
      <p>KPP: 771901001</p>
      <p>OGRN: 1227700848418</p>
     </div>
     <div className="address">
      <h2>Ünvan</h2>
      <p>
       105187, Rusiya, Moskva şəhəri, Okrujnoy prospekti, 15/2, 5-ci mərtəbə, I otaq,
       27A otaq
      </p>
     </div>
     <div className="feedback">
      <h2>Geri əlaqə</h2>
      <div className="email">
       <img src={MailIconSvg} />
       <a href="mailto:info@squaddevs.com">info@squaddevs.com</a>
      </div>
      <div className="phone">
       <img src={PhoneIconSvg} />
       <a href="tel:+79857387961" target="_blank">
        +7 (985) 738-79-61
       </a>
      </div>
      <div className="vk">
       <img src={LogoVk} />
       <a href="https://vk.com/squadDevs" target="_blank">
        vk.com/squadDevs
       </a>
      </div>
      <div className="tg">
       <img src={LogoTg} />
       <a href="https://t.me/devs_squad" target="_blank">
        t.me/devs_squad
       </a>
      </div>
     </div>
    </div>
    <div className="map">
     <YMaps>
      <Map
       width={`${width <= 767 ? (width <= 470 ? '240px' : '320px') : '512px'}`}
       height={`${width <= 767 ? (width <= 470 ? '240px' : '320px') : '512px'}`}
       defaultState={{ center: [55.788717, 37.741908], zoom: 16 }}
      >
       <Placemark geometry={[55.788717, 37.741908]} />
      </Map>
     </YMaps>
    </div>
   </div>
  </div>
 )
})

export { ContactsPage }
